import _ from 'lodash'
import moment from 'moment'
import { CancelToken } from 'axios'

import {
  FETCHING_MYD_PLANNINGS,
  FETCHED_MYD_PLANNINGS,
  FETCHING_MYD_PLANNING,
  FETCHED_MYD_PLANNING,
  NEW_MYD_PLANNING,
  SAVE_MYD_PLANNING,
} from '_reducers/myd_plannings'
import { MydAPI } from '_services/default'
import { deserializeMydEvaluation } from '_actions/myd_evaluations'
import { deserializeRelationship } from 'utils/relationships'
import {
  returnDateFormated,
  returnDateLocal,
} from 'utils/dates'


function _fetchingMydPlanning(removeOldData=true) {
  return {
    type: FETCHING_MYD_PLANNING,
    removeOldData,
  }
}

export function _fetchedMydPlanning(mydPlanning) {
  return { type: FETCHED_MYD_PLANNING, mydPlanning }
}

function _newMydPlanning(mydPlanning) {
  return { type: NEW_MYD_PLANNING, mydPlanning }
}

function _saveMydPlanning(mydPlanning) {
  return { type: SAVE_MYD_PLANNING, mydPlanning }
}

export function _deserializeMydPlanningData(mydPlanning, included) {
  let { id, attributes, relationships } = mydPlanning

  return {
    ...(attributes),
    startDate: attributes.startDate ? returnDateLocal(attributes.startDate) : moment(),
    endDate: attributes.endDate ? returnDateLocal(attributes.endDate) : moment(),
    id: id,
    ownerId: attributes.createdBy,
    contents: [],
    sharedTeachersIds: _.chain(relationships).get('teachers.data', []).map(i => i.id).value(),
    treeNodesIds: _.chain(relationships).get('treenodes.data', []).map(i => _.parseInt(i.id)).value(),
    mydEvaluations: (relationships && relationships.mydEvaluations) && deserializeRelationship(relationships.mydEvaluations, included, deserializeMydEvaluation),
  }
}

function _serializeMydPlanningData(planning) {
  let { name, description, startDate, endDate, treeNodesIds, sharedTeachersIds } = planning

  return {
    type: 'myd_planning',
    attributes: {
      name,
      description,
      'start_date': returnDateFormated(startDate),
      'end_date': returnDateFormated(endDate, false),
    },
    relationships: {
      teachers: {
        data: _.map(sharedTeachersIds, i => ({ type: 'teachers', id: _.toString(i)})),
      },
      treenodes: {
        data: _.map(treeNodesIds, i => ({ type: 'tree_node', id: _.toString(i)})),
      },
    }
  }
}

let fetchMydPlanningCancelToken = null

export function fetchMydPlanning(id) {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_fetchingMydPlanning())

    if (fetchMydPlanningCancelToken)
      fetchMydPlanningCancelToken()

    MydAPI.get(
      `/myd/plannings/${id}?include=treenodes,teachers,myd_evaluations.myd_activity`,
      {
        cancelToken: new CancelToken(function executor(c) {
          fetchMydPlanningCancelToken = c
        }),
      }
    ).then(res => {
      const newMydPlanning = _deserializeMydPlanningData(res.data.data, res.data.included)
      dispatch(_fetchedMydPlanning(newMydPlanning))
      resolve(newMydPlanning)

    }).catch(err => {
      if (err.__CANCEL__ !== true) {
        reject(err)
      }
    })
  })
}

export function saveMydPlanning(planning) {

  return dispatch => new Promise((resolve, reject) => {
    let id = _.get(planning, 'id', false),
        data = _serializeMydPlanningData(planning)

    if (id === false) {
      MydAPI.post(`/myd/plannings?include=treenodes,teachers,myd_evaluations.myd_activity`, {data}).then(res => {
        const newMydPlanning = _deserializeMydPlanningData(res.data.data, res.data.included)

        dispatch(_newMydPlanning(newMydPlanning))
        resolve(newMydPlanning)

      }).catch(reject)

    } else {
      data = {
        ...data,
        id: _.toString(id),
      }

      MydAPI.patch(`/myd/plannings/${id}?include=treenodes,teachers,myd_evaluations.myd_activity`, {data}).then(res => {
        let newMydPlanning = _deserializeMydPlanningData(res.data.data, res.data.included)

        dispatch(_saveMydPlanning(newMydPlanning))
        resolve(newMydPlanning)

      }).catch(reject)
    }
  })
}


export function deleteMydPlanning(id) {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_fetchingMydPlannings(false))

    MydAPI.delete(`/myd/plannings/${id}`).then( () => {
      fetchMydPlannings()(dispatch).then(mydPlannings => {
        resolve(mydPlannings)

      }).catch(reject)

    }).catch(reject)
  })
}

// ACTIONS FOR PLANNINGS

function _fetchingMydPlannings(removeOldData=true) {
  return {
    type: FETCHING_MYD_PLANNINGS,
    removeOldData,
  }
}

function _fetchedMydPlannings(mydPlannings) {
  return {
    type: FETCHED_MYD_PLANNINGS,
    mydPlannings
  }
}

let fetchMydPlanningsCancelToken = null

export function fetchMydPlannings(page=1) {
  return dispatch => new Promise((resolve, reject) => {

    if (fetchMydPlanningsCancelToken)
      fetchMydPlanningsCancelToken()

    dispatch(_fetchingMydPlannings())

    MydAPI.get(
      `/myd/plannings`,
      {
        cancelToken: new CancelToken(function executor(c) {
          fetchMydPlanningsCancelToken = c
        }),
        params: {
          include: 'treenodes,teachers,myd_evaluations.myd_activity',
          'page[number]': page,
        }
      }
    ).then(res => {
      let newMydPlannings = _.map(
        res.data.data,
        planning => _deserializeMydPlanningData(planning, res.data.included)
      )

      let data = {
        data: newMydPlannings,
        maxPage: _.ceil(res.data.meta.count / 10)
      }

      dispatch(_fetchedMydPlannings(data))
      resolve(data)
    }).catch(err => {
      if (err.__CANCEL__ !== true) {
        reject(err)
      }
    })
  })
}

export function searchMydPlannings(filters={}, page=1) {
  return new Promise((resolve, reject) => {
    MydAPI.get(
      `/myd/plannings`,
      {
        'params': {
          ...filters,
          'page[number]': page,
          sort: '-modified_at',
          'fields[myd_planning]': 'name,description,permissions',
        }
      }
    ).then(
      res => {
        let foundMydPlannings = _.map(
          res.data.data,
          planning => _deserializeMydPlanningData(planning, res.data.included)
        )

        resolve({
          data: foundMydPlannings,
          maxPage: _.ceil(res.data.meta.count / 10)
        })
      }
    ).catch(err => {
      reject(err)
    })
  })
}
